import FluxUtils from 'flux/utils';

import AuthenticationActions from 'sharedreact/actions/AuthenticationActions';
import NavigationActions from 'sharedreact/actions/NavigationActions';
import ChangePasswordDialog from 'sharedreact/components/ChangePasswordDialog';
import User from 'sharedreact/data/User';
import UserWithPassword from 'sharedreact/data/UserWithPassword';
import AuthenticationStore from 'sharedreact/stores/AuthenticationStore';
import NavigationStore from 'sharedreact/stores/NavigationStore';
import asFunctional from 'sharedreact/components/asFunctional';
import SettingsStore from 'sharedreact/stores/SettingsStore';

const _dialogId: string = 'shared.view.changepassword';

function handleClose (): void {
  NavigationActions.hideDialog(_dialogId);
}

function handleShow (): void {
  AuthenticationActions.resetChangePasswordRequest();
}

function handleChangePassword (currentPassword: string, newPassword: string): void {
  const currentUser: User | null = AuthenticationStore.getUser();
  if (currentUser) {
    const currentUserWithPassword: UserWithPassword = new UserWithPassword({
      user: currentUser,
      password: currentPassword
    });
    AuthenticationActions.changePassword(currentUserWithPassword, newPassword);
  }
}

type State = ConstructorParameters<typeof ChangePasswordDialog>[0];

function getStores () {
  return [
    AuthenticationStore,
    NavigationStore,
    SettingsStore
  ];
}

function calculateState (prevState?: State): State {
  const show: boolean = NavigationStore.isDialogVisible(_dialogId);
  return {
    show: show,
    language: SettingsStore.getLanguage(),
    activeUser: AuthenticationStore.getUser(),
    requestFinished: AuthenticationStore.getState().changePasswordRequestFinished,
    requestResult: AuthenticationStore.getState().changePasswordRequestResult,
    onClose: handleClose,
    onShow: handleShow,
    onChangePassword: handleChangePassword
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(ChangePasswordDialog),
  getStores,
  calculateState
);
